export default "__VITE_ASSET__oo_Tha0q__"